export default __webpack_public_path__ + "static/media/not_found_course.34dab548.svg";